import React from 'react'
import '../assets/css/loader.css'

const Loader = () => {
    return (
        <div className="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}

export default Loader